import BaseService from "./BaseService";

export default class MessageService extends BaseService {
  static endPoint = "message";
}
